import type { HTMLAttributes } from "react";

import { XIcon } from "../../components";
import { cn } from "../../utils";

export type AlertCloseProps = HTMLAttributes<HTMLButtonElement>;

const Close = ({ children, className, ...props }: AlertCloseProps) => {
  return (
    <button className={cn("absolute top-4 right-4", className)} {...props} type="button">
      {children || <XIcon className="h-5 w-5 min-w-5" />}
    </button>
  );
};

export default Close;
